export default "__VITE_ASSET__CHg$NNGU__"